import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZGFpc3kxMjMyMSIsImEiOiJjbGhhejhjNW8wbWduM2hvaThvOTgzamdpIn0.sLKvL0-cxWSUp_8awXxiJg";

const getBounds = (t) => {
  return [
    [t.longitude - 1.5 * t.width, t.latitude - 1.5 * t.width],
    [t.longitude + 1.5 * t.width, t.latitude + 1.5 * t.width],
  ];
};
const getPolygon = (t) => {
  const coords = t
    ? [
        [t.longitude - t.width, t.latitude - t.width],
        [t.longitude - t.width, t.latitude + t.width],
        [t.longitude + t.width, t.latitude + t.width],
        [t.longitude + t.width, t.latitude - t.width],
        [t.longitude - t.width, t.latitude - t.width],
      ]
    : [];
  return {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [coords],
    },
  };
};

const highResolutionTileLayer = "high_resolution-tilesets-layer";
const delineationOverlayLayers = [
  "parcels",
  "parcelsOutline",
  "circle",
  "task-outline",
];

export function orderDelineationLayers(map) {
  if (!map) {
    return;
  }
  if (map.getLayer(highResolutionTileLayer)) {
    map.moveLayer(highResolutionTileLayer);
  }
  delineationOverlayLayers.forEach((layerId) => {
    if (map.getLayer(layerId)) {
      map.moveLayer(layerId);
    }
  });
  const drawLayers =
    map
      .getStyle?.()
      .layers?.filter((layer) => layer.id.startsWith("gl-draw-")) || [];
  drawLayers.forEach((layer) => map.moveLayer(layer.id));
}

export function setHighResolutionVisibility(map, visible) {
  if (map?.getLayer(highResolutionTileLayer)) {
    map.setLayoutProperty(
      highResolutionTileLayer,
      "visibility",
      visible ? "visible" : "none",
    );
  }
}

export function updateLayer(map, country) {
  if (!map || typeof country !== "string" || !country) {
    return;
  }

  if (country == "united_states_of_america") {
    orderDelineationLayers(map);
    return;
  }
  let country_name = country;
  if (country.startsWith("nigeria")) {
    country_name = "nigeria";
  }
  const awsRegion = "eu-central-1";
  const layer = {
    id: "high_resolution",
    href:
      "https://mosaics-gta-prod-" +
      awsRegion +
      ".s3." +
      awsRegion +
      ".amazonaws.com/" +
      country_name +
      "/high_resolution/" +
      country_name +
      "-high_resolution-all.json",
    texts: "High Resolution Image",
    region: "eu-central-1",
    satellite: "high_resolution",
    params: [
      ["bands", "red"],
      ["bands", "green"],
      ["bands", "blue"],
    ],
    colorMap: {
      min: 0,
      max: 255,
    },
  };

  const sourceLayer = layer.id + "-tilesets";
  const titilerStage = "prod";
  const server =
    "https://gta-titiler-" +
    awsRegion +
    "-lambda-" +
    titilerStage +
    ".groundtruthanalytics.com";
  const url =
    server +
    "/mosaic/" +
    layer.satellite +
    "/tiles/WebMercatorQuad/{z}/{x}/{y}";

  const query = new URLSearchParams(layer.params);
  query.append("url", layer.href);

  if (layer.colorMap?.min !== undefined) {
    const offset = layer.colorMap?.offset || 0;
    query.append("rescale", [
      layer.colorMap.min + offset,
      layer.colorMap.max + offset,
    ]);
  }
  if (layer.colorMap?.colorMapName) {
    query.append("colormap_name", layer.colorMap.colorMapName.toLowerCase());
  }
  const new_tiles = [url + "?" + query.toString()];
  if (map.getSource(sourceLayer)) {
    map.getSource(sourceLayer).tiles = new_tiles;
    map.style.sourceCaches?.[sourceLayer].clearTiles();
    map.style.sourceCaches?.[sourceLayer].update(map.transform);
    map.triggerRepaint();
  } else {
    map.addSource(sourceLayer, {
      type: "raster",
      tiles: new_tiles,
    });
    map.addLayer({
      id: sourceLayer + "-layer",
      type: "raster",
      source: sourceLayer,
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: "visible",
      },
    });
  }
  orderDelineationLayers(map);
}

export const createMap = (container, task) => {
  const map = new mapboxgl.Map({
    container: container,
    style: "mapbox://styles/mapbox/streets-v12", // style URL
    interactive: true, // Needed for mapbox-gl-draw styling
    bounds: task?.latitude ? getBounds(task) : null,
    maxBounds: task?.latitude ? getBounds(task) : null,
  });
  map.addControl(new mapboxgl.ScaleControl());

  // Instead of restricting map to current viewport,
  // we show a yellow bounding box for the area to be delineated
  map.on("load", () => {
    map.addSource("task-boundary", {
      type: "geojson",
      data: getPolygon(task),
    });
    map.addLayer({
      id: "task-outline",
      type: "line",
      source: "task-boundary",
      layout: {},
      paint: {
        "line-color": "#ff0",
        "line-width": 3,
      },
    });
  });
  return map;
};

export const showTask = (map, task) => {
  const bounds = getBounds(task);
  // Allow map to show new point
  // Move the map to the central point
  map.fitBounds(bounds, { duration: 0 });

  // Add the boundary box
  map.getSource("task-boundary").setData(getPolygon(task));
};
